import React from 'react';
import { useTranslation } from 'react-i18next';
import { reportConversion } from '../utils/gtag';

const StickyCTA = () => {
  const { t } = useTranslation();
  const whatsappMessage = "Hi Vigor Auto, I'd like to book a service.";
  const whatsappUrl = `https://wa.me/971524333690?text=${encodeURIComponent(whatsappMessage)}`;

  const handleWhatsAppClick = () => {
    reportConversion(whatsappUrl);
  };

  const handleCallClick = (e) => {
    e.preventDefault();
  const url = 'tel:+971568699800';
    reportConversion(url);
    window.location.href = url;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 bg-opacity-90 backdrop-blur-sm p-2 flex justify-around items-center z-50 md:hidden shadow-lg">
      <a
        href={whatsappUrl}
        onClick={handleWhatsAppClick}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp to book a service"
        className="flex-1 flex items-center justify-center bg-green-500 text-white font-bold py-3 px-4 rounded-full mx-1 text-center transform transition-transform hover:scale-105 shadow-md"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" viewBox="0 0 24 24" fill="currentColor">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.433-9.89-9.889-9.89-5.452 0-9.887 4.434-9.889 9.891.001 2.23.651 4.385 1.886 6.245l-1.245 4.585 4.701-1.232z" />
        </svg>
        {t('nav.whatsapp')}
      </a>
      <a
  href="tel:+971524333690"
        onClick={handleCallClick}
        className="flex-1 flex items-center justify-center bg-blue-500 text-white font-bold py-3 px-4 rounded-full mx-1 text-center transform transition-transform hover:scale-105 shadow-md"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
        {t('common.callUs')}
      </a>
    </div>
  );
};

export default StickyCTA;
